<template>
  <section class="home-index">
    <proposals-approved-resume class="home-index-resume" />

    <section
      v-if="loading || values.count"
      class="home-index-listing"
    >
      <typography-heading class="home-index-heading">
        Você pode começar por aqui

        <template v-slot:subtitle>
          <template v-if="values.count === 1">
            Essa é a sua proposta aprovada mais recente
          </template>

          <template v-else>
            Essas são as suas
            {{ values.count > LIMIT ? LIMIT : values.count }}
            propostas aprovadas mais recentes
          </template>
        </template>
      </typography-heading>

      <context-separator
        class="home-index-separator"
        size="small"
      />

      <proposals-approved
        :per-page="LIMIT"
        :scrollable="false"
        class="home-index-approved"
      />

      <form-button
        :href="more"
        class="home-index-button"
      >
        Veja todas as

        <template v-if="values.count !== 1">
          {{ values.count }}
        </template>

        propostas aprovadas
      </form-button>
    </section>

    <!-- <home-prompt /> -->
    <home-news />
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import ProposalsApproved from '@sdk/views/Proposals/Approved.vue';
  import ProposalsApprovedResume from '@sdk/views/Proposals/Approved/Resume.vue';

  import FormButton from '@cordel/components/Form/Button.vue';
  import ContextSeparator from '@cordel/components/Context/Separator.vue';
  import TypographyHeading from '@cordel/components/Typography/Heading.vue';

  // import HomePrompt from '@/components/Home/Prompt.vue';

  import HomeNews from '@/views/Home/News.vue';

  const LIMIT = 3;

  export default {
    name: 'HomeIndex',
    components: {
      // HomePrompt,
      HomeNews,

      ProposalsApproved,
      ProposalsApprovedResume,

      FormButton,
      ContextSeparator,
      TypographyHeading,
    },
    data() {
      return {
        LIMIT,
        data: {
          name: 'proposals-approved',
        },
      };
    },
    computed: {
      ...mapState([
        'auth',
        'proposals',
      ]),

      loading() {
        return this.proposals.values.loading;
      },
      values() {
        return this.proposals.values.item;
      },

      more() {
        return {
          name: 'proposals-approved',
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .home-index {
  }

  .home-index-listing {
    overflow: hidden;
  }

  .home-index-heading {
    margin: var(--cordel-spacing-blaster) var(--product--pwa--horizontal) 0;

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin: var(--cordel-spacing-s) var(--product--pwa--horizontal) 0;
    }
  }

  .home-index-separator {
    margin-bottom: var(--cordel-spacing-giga);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin-bottom: 0;
    }
  }

  .home-index-resume {
    margin: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin: 0 var(--product--pwa--horizontal);
    }
  }

  .home-index-approved {
  }

  .home-index-button {
    margin: var(--cordel-spacing-giga) var(--product--pwa--horizontal) 0;

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin: var(--cordel-spacing-giga) var(--product--pwa--horizontal) 0;
    }
  }
</style>
